import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import configureStore from "./store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "../src/assets/css/style.css";
import "../src/assets/css/ownStyle.css";
import "../src/assets/css/networkPortalstyle.css";
import "../src/assets/css/modalPopupStyle.css";
import "../src/assets/css/networkintelligence.css";
import "../src/assets/css/newOwnStyle.css";
import reportWebVitals from "./reportWebVitals";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore()}>
    <BrowserRouter basename="/ProvidersPortal">
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
